import { render, staticRenderFns } from "./ReportTypeList.vue?vue&type=template&id=64cd73f9"
import script from "./ReportTypeList.vue?vue&type=script&lang=js"
export * from "./ReportTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports